<template>
	<div class="fields-definition-builder">
		<div>
			<div v-for="(fieldDef, index) in fieldsDefinitions" :key="index">
				<FieldDefinition
					class="mt-4"
					:fieldTitleText="fieldTitleText"
					:fieldDefinition="fieldDef"
					:isShowErrors="isShowErrors"
					:subflowsUsageWorkflowIds="subflowsUsageWorkflowIds"
					:fieldTypeText="fieldTypeText"
					@onFieldDefinition="(...args) => onFieldDefinition(index, ...args)"
					@deleteFieldDefinition="(...args) => deleteFieldDefinition(index, ...args)"
					@duplicateFieldDefinition="(...args) => duplicateFieldDefinition(index, ...args)"
				/>
			</div>
		</div>
		<OutlinedButton class="outlined-button mt-5" @click="addField" :disabled="isDisabled" :loading="isDisabled">{{
			buttonText
		}}</OutlinedButton>
	</div>
</template>

<script>
import FieldDefinitionService from './field-definition-service';

import FieldDefinition from './FieldDefinition.vue';

export default {
	name: 'FieldsDefinitionBuilder',
	components: { FieldDefinition },
	props: {
		fieldsDefinitions: { type: Array, default: () => [] },
		fieldTitleText: { type: String },
		buttonText: { type: String },
		fieldTypeText: { type: String },
		isShowErrors: { type: Boolean },
		isDisabled: { type: Boolean },
		subflowsUsageWorkflowIds: { type: Array },
	},
	data() {
		return {};
	},
	computed: {},
	methods: {
		onFieldDefinition(index, value) {
			const newFieldsDef = this.fieldsDefinitions[index];
			Object.assign(newFieldsDef, value);
			this.$emit('onFieldsDefChanged', this.fieldsDefinitions);
		},
		deleteFieldDefinition(index) {
			const newFieldsDef = this.fieldsDefinitions.filter((fd, fdIndex) => fdIndex !== index);
			this.$emit('onFieldsDefChanged', newFieldsDef);
		},
		duplicateFieldDefinition(index) {
			const newFieldDef = { ...this.fieldsDefinitions[index] };
			delete newFieldDef.id;
			delete newFieldDef.uuid;

			const oldDefName = newFieldDef.name;
			const newSuffix = `${oldDefName} copy`;
			const nextIndex = this.fieldsDefinitions.reduce((res, currentField) => {
				if (currentField.name.includes(oldDefName)) {
					const currentIndex = parseInt(currentField.name.replace(newSuffix, '').replace('(', '').replace(')', ''));
					return isNaN(currentIndex) ? res : currentIndex + 1;
				}
				return res;
			}, 1);
			this.$emit('onFieldsDefChanged', this.fieldsDefinitions.concat([{ ...newFieldDef, name: `${newSuffix} (${nextIndex})` }]));
		},
		addField() {
			const nextIndex = this.fieldsDefinitions.reduce((res, currentField) => {
				const currentIndex = parseInt(currentField.name.replace('field', ''));
				return isNaN(currentIndex) ? res : currentIndex + 1;
			}, 1);
			this.$emit('onFieldsDefChanged', this.fieldsDefinitions.concat([FieldDefinitionService.getFieldsDefinition(`field${nextIndex}`)]));
		},
	},
};
</script>

<style scoped lang="scss">
.fields-definition-builder {
	.outlined-button {
		width: 100%;
		border: 1px dashed var(--publish-button-background) !important;
		color: var(--publish-button-background) !important;
	}
}
</style>
